import { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

export default class Gallery extends Component{
	constructor(props){
		super();
		this.state = {
			gallery: {}
		}
	}
	componentDidMount() {
		fetch('http://caseymoir.com/gallery.json').then(response => response.json()).then(data => {
			this.setState({ gallery: data });
		});
	}
	render(){
		if(typeof this.state.gallery === 'object' && this.state.gallery !== null && Object.keys(this.state.gallery).length > 0){
			return(
				<div className="gallery">
					<ImageGallery
						ref={this.imgGal}
						items={this.state.gallery[this.props.selected]}
						showThumbnails={false}
						autoPlay={true}
						slideInterval={6000}
						slideDuration={700}
						additionalClass="galleryContainer"
						showFullscreenButton={false}
					/>
				</div>
			);
		}else {
			return null;
		}
	}
}